module.exports = __webpack_public_path__ + "img/import_done.ebcc7ea.png";